/* SUNVOLT – stäng desktop-hamburgaren vid klick på backdropen (utanför panelen).
   Backdropen är .menu-drawer-container::after (pointer-events:auto när öppen). Klick på en
   pseudo-element riktas mot värd-elementet → e.target === .menu-drawer-container. Då stänger
   vi via summaryns klick (Dawns HeaderDrawer stänger då med animation). ✕ och Esc funkar
   sedan tidigare. Klick på själva panelen/länkarna eller ✕ träffar inte container-elementet. */
(function () {
  function closeOpenDrawer() {
    var det = document.querySelector('.menu-drawer-container[open]');
    if (!det) return;
    var summary = det.querySelector('summary');
    if (summary) summary.click(); // Dawns HeaderDrawer stänger med animation
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      // 1) Stäng-✕ inne i panelen (.sv-menu-close / [data-sv-menu-close])
      if (t && t.closest && t.closest('[data-sv-menu-close]')) {
        e.preventDefault();
        closeOpenDrawer();
        return;
      }
      // 2) Klick på backdropen (pseudo-::after → target === .menu-drawer-container)
      if (t && t.classList && t.classList.contains('menu-drawer-container') && t.hasAttribute('open')) {
        closeOpenDrawer();
      }
    },
    false
  );
})();
